module.exports = __webpack_public_path__ + "img/power-swiper-item (4).ee71e688.png";